import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openSlideShowFullview } from "../../store/slices/gallerySlice";
export const useFavoritesImageViewer = () => {
  const [showFullView, setShowFullView] = useState({ index: 0, isOpen: false });
  const { quickSlideShowActions } = useSelector((state) => state.gallery);
  let dispatch = useDispatch();

  const handleOpenImageFullView = (i, id) => {
    setShowFullView({
      imageId: id,
      index: i,
      isOpen: true,
      type: "favorites",
    });
  };

  const closeSlideShowViewHandler = (i) => {
    let data = {
      isOpen: false,
      type: "favorites",
    };
    dispatch(openSlideShowFullview(data));
    setShowFullView({
      ...showFullView,
      index: i,
      isOpen: true,
    });
  };

  const handleCloseAfterClickedEscape = (i) => {
    if (quickSlideShowActions?.favorites?.showSlideShowContainer) {
      setShowFullView({
        ...showFullView,
        index: i,
        isOpen: true,
      });
    }
    let data = {
      isOpen: false,
      type: "favorites",
    };
    dispatch(openSlideShowFullview(data));
  };

  useEffect(() => {
    if (quickSlideShowActions?.favorites?.showSlideShowContainer) {
      setShowFullView({
        ...showFullView,
        index: "",
        isOpen: false,
      });
    }
  }, [quickSlideShowActions?.favorites?.showSlideShowContainer]);

  return {
    handleOpenImageFullView,
    closeSlideShowViewHandler,
    handleCloseAfterClickedEscape,
    showFullView,
    setShowFullView,
  };
};
